import { cx } from 'emotion'
import styled from 'react-emotion'

import * as icons from 'assets/icons/groove'
import { Tooltip } from 'shared/ui'
import themeVars from 'ui_theme/site/globals/site.variables'

export default styled(KeyValue)`
  display: flex;
  color: rgb(79, 93, 106);
  font-size: ${themeVars.medium};
  font-weight: ${themeVars.graphikWeightMedium};
  margin-bottom: ${themeVars.mini};

  &:last-child {
    margin-bottom: 0;
  }

  .divider {
    line-height: 22px;
    padding-right: ${themeVars.nano};
  }
  .key {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    min-width: 0;
    cursor: pointer;
    flex-grow: 0;
    flex-shrink: 0;
    line-height: 22px;
  }

  .icon {
    height: 22px;
    padding-right: ${themeVars.nano};
    .fill {
      fill: ${themeVars.lightGray};
    }
  }

  .value {
    cursor: pointer;
    font-weight: ${themeVars.graphikWeightRegular};
    text-align: left;
    min-width: 0;
    line-height: 22px;
    flex-grow: 1;

    &.singleline,
    .singleline {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }

  .action {
    cursor: pointer;
    border-radius: ${themeVars.defaultBorderRadius};
    padding: 2px 3px;
    width: 22px;
    height: 22px;
    text-align: center;
    display: none;
    flex-shrink: 0;
    flex-grow: 0;

    &:hover {
      background: ${themeVars.ultraDust};
    }

    .icon {
      height: ${themeVars.large};
      padding: 0;
      margin: 0;
      color: ${themeVars.ultraLight};
    }
  }

  &:hover .action {
    display: block;
  }
`

function KeyValue({
  children,
  className,
  icon,
  singleline = false,
  title,
  value,
}) {
  const KeyIcon = icons[icon]

  return (
    <div className={className}>
      {KeyIcon && <KeyIcon className="icon" />}
      <div className="key">{title}</div>
      <div className="divider">:</div>
      <Tooltip
        className={cx('value', { singleline })}
        tooltipClassName="value"
        position="left"
        portal
        tooltip={value}
      >
        {value}
      </Tooltip>
      {children}
    </div>
  )
}
